import {
  Component,
  EventEmitter,
  forwardRef,
  Host,
  Input,
  OnInit,
  Optional,
  Output,
  SkipSelf,
  TemplateRef
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputWrapperComponent} from '../input-wrapper/input-wrapper.component';
import {CheckboxChangeEvent, CheckboxModule} from 'primeng/checkbox';
import {
  AbstractControl,
  ControlContainer,
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import {TooltipModule} from "primeng/tooltip";
import {InputTextModule} from "primeng/inputtext";

@Component({
  selector: 'app-checkbox',
  standalone: true,
  imports: [CommonModule, InputWrapperComponent, CheckboxModule, FormsModule, ReactiveFormsModule, TooltipModule, InputTextModule],
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    }
  ],
})
export class CheckboxComponent implements ControlValueAccessor, OnInit {
  @Input() label?: string;
  @Input() required?: boolean;
  @Input() readonly?: boolean;

  @Input() readonlyAsText?: boolean;
  @Input() inputID: string;
  @Input() formControlName: string;
  @Input() disabled?: boolean;
  @Input() tooltip: string | TemplateRef<HTMLElement> | undefined;

  @Output() onCheckboxChange = new EventEmitter<CheckboxChangeEvent>();

  value: boolean;
  control: AbstractControl<any, any>

  constructor(@Optional() @Host() @SkipSelf() protected controlContainer: ControlContainer) {
  }

  ngOnInit() {
    if (this.controlContainer) {
      if (this.formControlName) {
        this.control = this.controlContainer.control.get(this.formControlName);
      } else {
        console.warn('Missing FormControlName directive from host element of the component');
      }
    } else {
      console.warn('Can\'t find parent FormGroup directive');
    }
  }

  onChange = (value: boolean) => {
  };
  onTouched = () => {
  };

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  handleCheckboxChange(event: CheckboxChangeEvent): void {
    this.value = event.checked;
    this.onChange(this.value);
    this.onTouched();
    this.onCheckboxChange.emit(event)
  }
}

